import React, { useState, useRef, useEffect } from 'react';
import { Globe, ChevronDown, Check } from 'lucide-react';
import { useRegion } from '../contexts/RegionContext';

const RegionSelector = () => {
  const { region, setRegion, regions, t } = useRegion();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        data-testid="region-selector-btn"
        className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-neutral-300 hover:text-white hover:bg-white/5 transition-all"
      >
        <Globe className="w-4 h-4" />
        <span className="hidden sm:inline">{region.flag} {region.langName}</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 top-full mt-2 w-72 bg-[#242424] rounded-xl border border-white/10 shadow-2xl overflow-hidden z-50">
          {/* Header */}
          <div className="px-4 py-3 bg-gradient-to-r from-[#F7B731]/20 to-[#F26419]/20 border-b border-white/10">
            <div className="flex items-center gap-2">
              <Globe className="w-4 h-4 text-orange-400" />
              <span className="text-sm font-medium text-white">{t('select_region')}</span>
            </div>
          </div>

          {/* Region List */}
          <div className="max-h-80 overflow-y-auto">
            {regions.map((r) => (
              <button
                key={r.code}
                onClick={() => {
                  setRegion(r);
                  setIsOpen(false);
                }}
                data-testid={`region-option-${r.code}`}
                className={`w-full flex items-center justify-between px-4 py-3 hover:bg-white/5 transition-colors ${
                  region.code === r.code ? 'bg-orange-500/10' : ''
                }`}
              >
                <div className="flex items-center gap-3">
                  <span className="text-xl">{r.flag}</span>
                  <div className="text-left">
                    <p className="text-sm font-medium text-white">{r.name}</p>
                    <p className="text-xs text-neutral-500">{r.langName} • {r.currency}</p>
                  </div>
                </div>
                {region.code === r.code && (
                  <Check className="w-4 h-4 text-orange-500" />
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default RegionSelector;
